import ChannelsService from 'data/ChannelsService';
import MockChannel from 'components/channel/MockChannel';
import React from 'react';
import { Button } from 'primereact/button';


let _numSensors = 0;

const _getSensorName = index => `Sensor ${index}`;
const _getSensorUnits = index => ['s', 'ppm', 'mm', 'psi', 'Hz'][index % 5];


class MockChannelConnect extends React.Component {
  constructor() {
    super();
    this.channelsService = new ChannelsService.Factory().create();
  }

  addChannel() {
    _numSensors++;
    const channel = new MockChannel(
        _getSensorName(_numSensors), _getSensorUnits(_numSensors));
    this.channelsService.add(channel.getId(), channel);
  }

  render() {
    return (
      <Button
          icon='pi pi-plus'
          label={this.props.label}
          onClick={this.addChannel.bind(this)} />
    );
  }
}


export default MockChannelConnect;
